// Cross-fade used when preview cards (invoice, quote) swap between their
// collapsed and expanded contents, paired with a height animation on the
// container.
export const crossFadeMotionProps = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.2, ease: 'easeInOut' }
} as const
